// CopyTroopSchedule.js
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  isAddMode,
  isEditMode,
  isReadOnlyMode,
  ROUTE_PATHS,
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./CopyTroopScheduleConfig";
import { screenInfo } from "./CopyTroopScheduleConfig";

const CopyTroopSchedule = ({ mode }) => {
  const location = useLocation();
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.TROOP_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();
  const initialFormData = useMemo(() => {
    const {
      tscScheduleName: parTscScheduleName = "",
      tscDescription: parTscDescription = "",
    } = selectedSchedules[currentIndex];
    return {
      parTscScheduleName,
      parTscDescription,
      dtlTscScheduleName: "",
      dtlTscDescription: "",
    };
  }, [selectedSchedules, currentIndex]);

  const lastValidOpcScheduleName = useRef("");
  const handleBack = () => {
    const lastScheduleName =
      selectedSchedules[currentIndex]?.dtlTscScheduleName;
    if (lastScheduleName) {
      lastValidOpcScheduleName.current = lastScheduleName;
    }
    /* const updatedParamsData = {
      ...currentState.paramsData,
      tscScheduleName: lastValidOpcScheduleName.current,
    };*/
    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      /*navigateToPage(previousScreen, [
        ...previousState,
        {
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
      ]);*/
      const lastRecord = previousState.pop() ?? {};
      const updatedLastRecord = lastValidOpcScheduleName.current
        ? {
            ...lastRecord,
            paramsData: {
              tscScheduleName: lastValidOpcScheduleName.current,
              hiddenRecordIndicator: "Active",
            },
          }
        : lastRecord;
      const updatedPreviousState = [...previousState, updatedLastRecord];
      navigateToPage(previousScreen, updatedPreviousState);
    }
  };

  const getPageTitle = () => {
    const { screenTitle, screenNumber } = screenInfo;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    const data = {
      ...dataForSubmission,
      screenNumber: screenInfo.screenNumber,
    };
    const url = "api/tscTroopScheduleCtl/copy";
    const verb = "POST";
    try {
      const { responseStatus } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      selectedSchedules[currentIndex].dtlTscScheduleName =
        data.dtlTscScheduleName;
      selectedSchedules[currentIndex].dtlTscDescription =
        data.dtlTscDescription;
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};
    keyFunc.F12 = handleBack;
    keyName.F12 = "Back";
    return [keyFunc, keyName];
  }, [currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={mode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default CopyTroopSchedule;
